document.addEventListener('DOMContentLoaded', function() {
    
    // Get header height
    const header = document.querySelector('#shopify-section-header');
    const headerHeight = header ? header.offsetHeight : 0;

    document.body.style.setProperty('--header-height', headerHeight + 'px');

    // sticky top bar
    const sections = document.querySelectorAll('.cust-collection-grid');
    sections.forEach(function(section) {
      const topBar = section.querySelector('.ccg-top__bar');
      if (!topBar) return;
      const barTop = topBar.offsetTop;

      window.addEventListener('scroll', function() {
        const scrollTop = window.scrollY;
        if (scrollTop >= barTop + headerHeight) {
          topBar.classList.add('fixed');
        } else {
          topBar.classList.remove('fixed');
        }
      });

      // popup logic
      const popup = section.querySelector('.ccg-filter-sort__popup');
      const popupInner = section.querySelector('.ccg-filter-sort__popup-content');
      const popupToggle = section.querySelector('.ccg-filter-sort__toggle');
      const popupCloseBtn = section.querySelector('.ccg-filter-sort__popup-close');

      if (!popup || !popupInner || !popupToggle || !popupCloseBtn) return;

      popupToggle.addEventListener('click', function() {
        popup.toggleAttribute('open');
      });

      popupCloseBtn.addEventListener('click', function() {
        popup.removeAttribute('open');
      });

      popup.addEventListener('click', function(e) {
        if (!popupInner.contains(e.target)) {
          popup.removeAttribute('open');
        }
      });

      // accordion logic
      const popupItemTitles = section.querySelectorAll('.ccg-filter-sort__popup-item-title');
      popupItemTitles.forEach(function(itemTitle) {
        itemTitle.addEventListener('click', function() {
          const parentItem = itemTitle.closest('.ccg-filter-sort__popup-item');
          if (parentItem) {
            parentItem.toggleAttribute('open');
          }
        });
      });

      // filter & Sort by logic
      const applyBtn = section.querySelector('.ccg-filter-sort__popup-footer-apply');
      const popupClearBtn = section.querySelector('.ccg-filter-sort__popup-footer-clear');
      const topClearBtn = section.querySelector('.ccg-filter-sort__clear');
      const productGrid = section.querySelector('#CollectionProductGrid');

      function updateTopClearButtonState() {
        if (!topClearBtn) return;
        const params = new URLSearchParams(window.location.search);
        const hasFilters = Array.from(params.keys()).some(key => key.startsWith('filter.') || key === 'sort_by');
        topClearBtn.classList.toggle('hidden', !hasFilters);
      }

      function buildSearchParamsFromPopup() {
        const params = new URLSearchParams(window.location.search);

        Array.from(params.keys()).forEach(function(key) {
          if (key.indexOf('filter.') === 0 || key === 'sort_by') {
            params.delete(key);
          }
        });
        params.delete('page');

        const filterInputs = popup.querySelectorAll(
          '.ccg-filter-sort__popup-item-list input[type="checkbox"], ' +
          '.ccg-filter-sort__popup-item-list input[type="radio"]:not([name="Sort by"])'
        );

        filterInputs.forEach(function(input) {
          if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
          if (!input.name) return;
          if (input.value === '' || input.value == null) return;
          params.append(input.name, input.value);
        });

        const priceInputs = popup.querySelectorAll('[data-filter-item="Price"] input[type="number"]');
        priceInputs.forEach(function(input) {
          if (!input.name) return;
          if (input.value === '' || input.value == null) return;
          params.set(input.name, input.value);
        });

        const sortRadio = popup.querySelector('[data-sort-by] input[type="radio"]:checked');
        if (sortRadio) {
          const sortValue = sortRadio.getAttribute('data-optionvalue') || sortRadio.value;
          if (sortValue) {
            params.set('sort_by', sortValue);
          }
        }

        return params;
      }
      let activeGridRequest;  
      let requestSeq = 0; 
      function renderGridWithParams(params, pushState = true) {
        requestSeq += 1;  
        const currentSeq = requestSeq;  
        if (activeGridRequest) activeGridRequest.abort();  
        activeGridRequest = new AbortController();  
        if (!productGrid) {
          const search = params.toString();
          const newUrl = search ? (window.location.pathname + '?' + search) : window.location.pathname;
          window.location.assign(newUrl);
          return;
        }

        const sectionId = productGrid.dataset.sectionId;
        const search = params.toString();
        const url =
          window.location.pathname +
          '?section_id=' +
          encodeURIComponent(sectionId) +
          (search ? '&' + search : '');

        productGrid.classList.add('loading');

        fetch(url, { signal: activeGridRequest.signal }) 
          .then(function(response) {
            if (!response.ok) throw new Error('Grid fetch failed'); 
            return response.text();
          })
          .then(function(html) {
            if (currentSeq !== requestSeq) return;  
            const dom = new DOMParser().parseFromString(html, 'text/html');
            const newGrid = dom.getElementById('CollectionProductGrid');
            if (newGrid) {
              productGrid.innerHTML = newGrid.innerHTML;
            }

            const newCount = dom.querySelector('.ccg-collection__count');
            const currentCount = section.querySelector('.ccg-collection__count');
            if (newCount && currentCount) {
              currentCount.innerHTML = newCount.innerHTML;
            }

            productGrid.classList.remove('loading');

            if (pushState) {
              const fullUrl = search
                ? window.location.pathname + '?' + search
                : window.location.pathname;
              history.pushState({ searchParams: search }, '', fullUrl);
            }

            const ev = new CustomEvent('paginate');
            document.dispatchEvent(ev);
            updateTopClearButtonState();
          })
          .catch(function(error) {  
            if (error.name === 'AbortError') return;  
            productGrid.classList.remove('loading');
            updateTopClearButtonState();
          });
      }

      function clearAllFilters(e) {
        e.preventDefault();
        const params = new URLSearchParams(window.location.search);

        Array.from(params.keys()).forEach(function(key) {
            if (key.indexOf('filter.') === 0 || key === 'sort_by') {
                params.delete(key);
            }
        });
        params.delete('page');

        if (popup) popup.removeAttribute('open');
        renderGridWithParams(params, true);
      }

      if (applyBtn) {
        applyBtn.addEventListener('click', function(e) {
          e.preventDefault();
          const params = buildSearchParamsFromPopup();
          popup.removeAttribute('open');
          renderGridWithParams(params, true);
        });
      }

      if (popupClearBtn) {
        popupClearBtn.addEventListener('click', clearAllFilters);
      }

      if (topClearBtn) {
        topClearBtn.addEventListener('click', clearAllFilters);
      }

      window.addEventListener('popstate', function(event) {
        const searchParamsString = (event.state && event.state.searchParams) || window.location.search.slice(1);
        const params = new URLSearchParams(searchParamsString);
        renderGridWithParams(params, false);
      });

      updateTopClearButtonState();
    });
  });
